exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".no-benefit-modal::before {\r\n  content: \"!\";\r\n  position: absolute;\r\n  top: -10px;\r\n  color: #fff;\r\n  font-size: 21px;\r\n  right: -10px;\r\n  width: 23px;\r\n  text-align: center;\r\n  line-height: 23px;\r\n  height: 23px;\r\n  z-index: 99;\r\n  border-radius: 50%;\r\n  background-color: #ed1c24;\r\n}\r\n\r\n.list-section-warning {\r\n  list-style: none;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./app/containers/FastCover/StepDeclaration/components/ModalNoBenefit/index.css
// module id = ./node_modules/css-loader/index.js!./app/containers/FastCover/StepDeclaration/components/ModalNoBenefit/index.css
// module chunks = 12